import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Slider from "react-slick";
import DOMPurify from "dompurify";

import { getBackendAssetsUrl } from "./../../config/Production";
import {
  getSubCategoryData,
  getProductsUnderSubCategory,
} from "./../../api/index";
import ProductSlider from "../../components/Sliders/ProductSlider";
import LoaderComponent from "../../components/Loader/LoaderComponent";

function SubCategory() {
  const { maincategory, subcategory } = useParams();
  const [loading, setLoading] = useState(false);
  const [backurl, setBackUrl] = useState("");
  const [foldername, setFolderName] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [categoryUrl, setCategoryUrl] = useState("");
  const [subCategory, setSubCategory] = useState([]);
  const [relatedProducts, setRelatedSubProducts] = useState([]);
  const [categoryImages, setCategoryImages] = useState([]);

  const categorySliderSettings = {
    dots: true,
    arrows: true,
    infinite: true,
    autoplay: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await getSubCategoryData({
          subCategory: subcategory,
        });
        const data = res.data.data;

        if (data.CategoryExist == "yes") {
          setSubCategory(data.CategoryData);
          setCategoryName(data.CategoryData.category_name);
          setCategoryUrl(data.CategoryData.category_url);
          setCategoryImages(data.CategoryData.category_images.split("|") || []);
          setFolderName(
            data.CategoryData.category_name.replaceAll(" ", "_").toLowerCase(),
          );

          const response = await getProductsUnderSubCategory({
            subCategory: subcategory,
          });

          setRelatedSubProducts(response.data.data.CategoryData.products);
        } else {
        }
      } catch (error) {
        console.error("Main category fetch error:", error);
      } finally {
        setLoading(false);
      }
    };
    setBackUrl(getBackendAssetsUrl());
    fetchData();
  }, [maincategory, subcategory]);

  return (
    <section className="category-detail-section clearfix">
      {loading == true ? (
        <LoaderComponent />
      ) : (
        <div className="container">
          {/* ================= CATEGORY DETAILS ================= */}
          <div className="row mb-60">
            {/* ================= MAIN CATEGORY IMAGE SLIDER ================= */}
            <div className="col-lg-6">
              <Slider {...categorySliderSettings}>
                {categoryImages.map((img, index) => (
                  <div key={index} className="category-slider-item">
                    <img
                      src={`${backurl}shop_sub_category/${foldername}/${img}_large.webp`}
                      alt={subCategory?.category_name}
                      className="img-fluid border-rad_20 w-100"
                    />
                  </div>
                ))}
              </Slider>
            </div>

            <div className="col-lg-6 text-center">
              <h2 className="mb-15">{subCategory.category_name}</h2>
              <div
                className="category-description mx-auto"
                style={{ maxWidth: "900px" }}
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(
                    subCategory.short_description || "",
                  ),
                }}
              ></div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12 col-12">
              <h4>Category Description</h4>
              <div
                className="category-description"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(
                    subCategory.long_description || "",
                  ),
                }}
              ></div>
            </div>
            <div className="col-lg-12 col-12">
              <h4>Category specifications</h4>
              <div
                className="category-description"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(subCategory.specifications || ""),
                }}
              ></div>
            </div>
          </div>

          <ProductSlider
            categoryName={categoryName}
            relatedProducts={relatedProducts}
            backurl={backurl}
          />
        </div>
      )}
    </section>
  );
}

export default SubCategory;
